import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * The API stores and returns UTC; NKS reads Kuala Lumpur (CLAUDE.md §7.5).
 * The conversion happens here, at the presentation layer, and nowhere else.
 */
export const APP_TIMEZONE = 'Asia/Kuala_Lumpur';

export function formatDateTime(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso.length === 0) return '—';
  return dayjs.utc(iso).tz(APP_TIMEZONE).format('D MMM YYYY, HH:mm');
}

export function formatDate(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso.length === 0) return '—';
  return dayjs.utc(iso).tz(APP_TIMEZONE).format('D MMM YYYY');
}

/** Renders an empty value as an em dash rather than a blank cell. */
export function orDash(value: string | null | undefined): string {
  return value === null || value === undefined || value.trim().length === 0 ? '—' : value;
}
